"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineFeedback = void 0;
var react_1 = __importStar(require("react"));
var ThumbsDown_1 = __importDefault(require("../../icons/ThumbsDown"));
var ThumbsUp_1 = __importDefault(require("../../icons/ThumbsUp"));
var InlineFeedback = function (_a) {
    var messageFeedbacks = _a.messageFeedbacks, messageId = _a.messageId, onFeedback = _a.onFeedback, intl = _a.intl;
    var _b = (0, react_1.useState)(false), feedbackSent = _b[0], setFeedbackSent = _b[1];
    (0, react_1.useEffect)(function () {
        if (messageFeedbacks && messageFeedbacks.find(function (x) { return x.messageId === messageId && x.feedback != null; })) {
            setFeedbackSent(true);
        }
    }, [messageFeedbacks]);
    var handleSendFeedback = function (feedback) {
        onFeedback(feedback, messageId);
        setFeedbackSent(true);
    };
    if (feedbackSent) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "bpw-message-feedback" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("button", { type: "button", "aria-label": intl.formatMessage({
                    id: 'message.thumbsUp',
                    defaultMessage: 'Thumbs Up'
                }), onClick: function () { return handleSendFeedback(1); } },
                react_1.default.createElement(ThumbsUp_1.default, null)),
            react_1.default.createElement("button", { type: "button", "aria-label": intl.formatMessage({
                    id: 'message.thumbsDown',
                    defaultMessage: 'Thumbs Down'
                }), onClick: function () { return handleSendFeedback(-1); } },
                react_1.default.createElement(ThumbsDown_1.default, null)))));
};
exports.InlineFeedback = InlineFeedback;
